import { REGEX, NUMBER_FORMAT } from '../constants';

export const decimalNumberValidation = (value: string | undefined) =>
  String(value)?.replace(
    REGEX.NIL_DECIMAL,
    NUMBER_FORMAT.DEFAULT_DECIMAL_VALUE
  );
